<div class="row animated fadeIn">
    <div class="col-md-12">
        <div class="d-flex justify-content-between align-items-center mb-2">
            <h4 class="mb-0"><a href="javascript:void(0);" routerLink="/contacts/contacts-list"><span
                        class="mdi mdi-arrow-left"></span></a> Add Contact</h4>
        </div>

        <div class="card">
            <div class="card-header">
                <h5 class="mb-0">Contact Information</h5>
            </div>

            <div class="card-body">
                <form [formGroup]="registerForm">
                    <div class="form-row">
                        <div class="form-group col-lg-3 col-md-3 col-sm-12">
                            <label for="" class="">Contact Name <span class="required">*</span>
                            </label>
                            <input type="text" class="form-control"
                                [ngClass]="{ 'is-invalid': submitted && f.ContactName.errors }"
                                formControlName="ContactName" placeholder="Contact Name"
                                (input)="NameSpaceNotAllowed($event)" maxlength="100">
                            <div *ngIf="submitted && f.ContactName.errors" class="invalid-feedback">
                                <div *ngIf="f.ContactName.errors.required"> Contact Name is required.</div>
                                <div *ngIf="f.ContactName.errors.pattern">Contact Name is not valid</div>
                            </div>
                        </div>

                        <div class="form-group col-lg-3 col-md-3 col-sm-12">
                            <label for="" class="">Mobile <span class="required">*</span>
                            </label>
                            <input class="form-control " type="text"
                                [ngClass]="{ 'is-invalid': submitted && f.Mobile.errors }" formControlName="Mobile"
                                placeholder="Ex. +974(Country code)85432778" maxlength="15"
                                (input)="NameSpaceNotAllowed($event)" />
                            <div *ngIf="submitted && f.Mobile.errors" class="invalid-feedback">
                                <div *ngIf="f.Mobile.errors.required">Mobile is required</div>
                                <div *ngIf="f.Mobile.errors.pattern">
                                    Mobile not valid.
                                </div>
                                <div *ngIf="f.Mobile.errors.minLength">
                                    Mobile must be at least 6 number.
                                </div>
                            </div>
                        </div>

                        <div class="form-group col-lg-3 col-md-3 col-sm-12">
                            <label for="" class="d-flex justify-content-between align-items-center">Landline
                            </label>
                            <input class="form-control " formControlName="Landline"
                                [ngClass]="{ 'is-invalid': submitted && f.Landline.errors }" type="text"
                                placeholder="Ex. +974(Country code)85432778" (input)="NameSpaceNotAllowed($event)" />
                            <div *ngIf="submitted && f.Landline.errors" class="invalid-feedback">
                                <div *ngIf="f.Landline.errors.required"></div>
                                <div *ngIf="f.Landline.errors.pattern">
                                    Landline is not valid.
                                </div>
                                <div *ngIf="f.Landline.errors.minLength">
                                    Landline must be at least 6 number.
                                </div>
                            </div>
                        </div>

                        <div class="form-group col-lg-3 col-md-3 col-sm-12">
                            <label for="" class="d-flex justify-content-between align-items-center">Whatsapp Number
                            </label>
                            <input class="form-control " formControlName="WhatsappNumber"
                                [ngClass]="{ 'is-invalid': submitted && f.WhatsappNumber.errors }" type="text"
                                placeholder="Ex. +974(Country code)85432778" (input)="NameSpaceNotAllowed($event)" />
                            <div *ngIf="submitted && f.WhatsappNumber.errors" class="invalid-feedback">
                                <div *ngIf="f.WhatsappNumber.errors.pattern">
                                    WhatsappNumber not valid.
                                </div>
                                <div *ngIf="f.WhatsappNumber.errors.minLength">
                                    WhatsappNumber must be at least 6 number.
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="form-group col-lg-3 col-md-3 col-sm-12">
                            <label for="" class="">Email <span class="required">*</span>
                            </label>
                            <input class="form-control " type="text" formControlName="Email"
                                [ngClass]="{ 'is-invalid': submitted && f.Email.errors }"
                                (input)="NameSpaceNotAllowed($event)" maxlength="320" />
                            <div *ngIf="submitted && f.Email.errors" class="invalid-feedback">
                                <div *ngIf="f.Email.errors.required">Email is required</div>
                                <div *ngIf="f.Email.errors.pattern">Email must be a valid email address</div>
                            </div>
                        </div>

                        <div class="form-group col-lg-3 col-md-3 col-sm-12">
                            <label for="" class="">Country <span class="required">*</span>
                            </label>
                            <angular2-multiselect formControlName="Country" [data]="CountryList"
                                [(ngModel)]="selectedCountry" [settings]="dropdownCountry"
                                [ngClass]="{ 'is-invalid': submitted && f.Country.errors}"
                                (onSelect)="onCountrySelect($event)" (onDeSelectAll)="onCountrySelect($event)"
                                fixSearchBug>
                            </angular2-multiselect>
                            <div *ngIf="submitted && f.Country.errors" class="invalid-feedback">
                                <div *ngIf="f.Country.errors.required">Country is required</div>
                            </div>
                        </div>
                        <div class="form-group col-lg-3 col-md-3 col-sm-12">
                            <label for="" class="">State<span class="required">*</span></label>
                            <angular2-multiselect formControlName="State" [data]="stateList" [(ngModel)]="selectedState"
                                [settings]="dropdownState" [ngClass]="{ 'is-invalid': submitted && f.State.errors}"
                                (onSelect)="onStateSelect($event)" (onDeSelectAll)="onStateSelect($event)" fixSearchBug>
                            </angular2-multiselect>
                            <div *ngIf="submitted && f.State.errors" class="invalid-feedback">
                                <div *ngIf="f.State.errors.required">State is required</div>
                            </div>
                        </div>
                        <div class="form-group col-lg-3 col-md-3 col-sm-12">
                            <label for="" class="">City<span class="required">*</span></label>
                            <angular2-multiselect formControlName="City" [data]="cityList" [(ngModel)]="selectedCity"
                                [settings]="dropdownCity" [ngClass]="{ 'is-invalid': submitted && f.City.errors}"
                                (onSelect)="onCitySelect($event)" (onDeSelectAll)="onCitySelect($event)" fixSearchBug>
                            </angular2-multiselect>
                            <div *ngIf="submitted && f.City.errors" class="invalid-feedback">
                                <div *ngIf="f.City.errors.required">City is required</div>
                            </div>
                        </div>
                        <div class="form-group col-lg-3 col-md-3 col-sm-12">
                            <label for="" class="d-flex justify-content-between align-items-center">Date Of Birth
                            </label>
                            <div class="input-group">
                                <input type="text" class="bg-calender-icon form-control "
                                    [bsConfig]="{ dateInputFormat: 'DD-MM-YYYY'}" placeholder="DD-MM-YYYY" bsDatepicker
                                    formControlName="DateOfBirth" (keydown)="disableDate()"
                                    [ngClass]="{ 'is-invalid': submitted && f.DateOfBirth.errors }"
                                    (input)="NameSpaceNotAllowed($event)">
                                <div *ngIf="submitted && f.DateOfBirth.errors" class="invalid-feedback">

                                    <div *ngIf="diff<10">
                                        Age Should be More Then 10 Years.
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="form-group col-lg-3 col-md-3 col-sm-12">
                            <label for="" class="d-flex justify-content-between align-items-center">Address Line1
                            </label>
                            <input class="form-control " formControlName="Address1"
                                [ngClass]="{ 'is-invalid': submitted && f.Address1.errors }" type="text"
                                (input)="NameSpaceNotAllowed($event)" maxlength="50" />
                        </div>

                        <div class="form-group col-lg-3 col-md-3 col-sm-12">
                            <label for="" class="d-flex justify-content-between align-items-center">Address Line2
                            </label>
                            <input class="form-control " formControlName="Address2"
                                [ngClass]="{ 'is-invalid': submitted && f.Address2.errors }" type="text"
                                (input)="NameSpaceNotAllowed($event)" maxlength="50" />
                        </div>
                    </div>

                    <h5 class="mb-3 pb-2 border-bottom mt-2 text-green">General Information</h5>

                    <div class="form-row">
                        <div class="form-group col-lg-3 col-md-3 col-sm-12">
                            <label for="" class="">Company <span class="required">*</span>
                            </label>
                            <angular2-multiselect formControlName="Company" [data]="companyList"
                                [(ngModel)]="selectedcompany" [settings]="dropdowncompany"
                                [ngClass]="{ 'is-invalid': submitted && f.Company.errors }"
                                (onSelect)="oncompanySelect($event)" (onDeSelectAll)="oncompanySelect($event)"
                                fixSearchBug>
                            </angular2-multiselect>
                            <div *ngIf="submitted && f.Company.errors" class="invalid-feedback">
                                <div *ngIf="f.Company.errors.required">company is required</div>
                            </div>
                        </div>
                        <div class="form-group col-lg-3 col-md-3 col-sm-12">
                            <label for="" class="">Designation <span class="required">*</span>
                            </label>
                            <angular2-multiselect formControlName="Designation" [data]="designationList"
                                [(ngModel)]="selectedDesignation" [settings]="dropdownDesignation"
                                [ngClass]="{ 'is-invalid': submitted && f.Designation.errors }"
                                (onSelect)="onDesignationSelect($event)" (onDeSelectAll)="onDesignationSelect($event)"
                                fixSearchBug>
                            </angular2-multiselect>
                            <div *ngIf="submitted && f.Designation.errors" class="invalid-feedback">
                                <div *ngIf="f.Designation.errors.required">Designation is required</div>
                            </div>
                        </div>

                        <div class="form-group col-lg-3 col-md-3 col-sm-12">
                            <label for="" class="">Contact Owner <span class="required">*</span>
                            </label>
                            <angular2-multiselect formControlName="ContactOwner" [data]="ownerList"
                                [(ngModel)]="selectedowner" [settings]="dropdownower"
                                [ngClass]="{ 'is-invalid': submitted && f.ContactOwner.errors }"
                                (onSelect)="onwnerSelect($event)" (onDeSelectAll)="onwnerSelect($event)" fixSearchBug>
                            </angular2-multiselect>
                            <div *ngIf="submitted && f.ContactOwner.errors" class="invalid-feedback">
                                <div *ngIf="f.ContactOwner.errors.required">
                                    contact owner is required.
                                </div>
                            </div>
                        </div>
                        <div class="form-group col-lg-3 col-md-3 col-sm-12">
                            <label for="" class="">Nationality <span class="required">*</span>
                            </label>
                            <angular2-multiselect formControlName="Nationality" [data]="CountryList"
                                [(ngModel)]="selectedNationality" [settings]="dropdownNationality"
                                [ngClass]="{'is-invalid': submitted && f.Nationality.errors}"
                                (onSelect)="onNationalitySelect($event)" (onDeSelectAll)="onNationalitySelect($event)"
                                fixSearchBug>
                            </angular2-multiselect>
                            <div *ngIf="submitted && f.Nationality.errors" class="invalid-feedback">
                                <div *ngIf="f.Nationality.errors.required">
                                    Nationality is required.
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="form-row">
                    </div>

                    <div class="form-row">
                        <div class="form-group col-lg-3 col-md-3 col-sm-12">
                            <label for="" class="d-flex justify-content-between align-items-center">Religion
                            </label>
                            <angular2-multiselect formControlName="Religion" [data]="religionList"
                                [(ngModel)]="selectedReligion" [settings]="dropdownReligion"
                                (onSelect)="onReligionSelect($event)" (onDeSelect)="onReligionSelect($event)"
                                (onDeSelectAll)="onReligionSelect($event)" fixSearchBug>
                            </angular2-multiselect>
                        </div>

                        <div class="form-group col-lg-3 col-md-3 col-sm-12">
                            <label for="" class="d-flex justify-content-between align-items-center">Language
                            </label>

                            <angular2-multiselect formControlName="Language" [data]="languageList"
                                [(ngModel)]="selectedLanguage" [settings]="dropdownLanguage"
                                [ngClass]="{ 'is-invalid': submitted && f.Language.errors }"
                                (onSelect)="onLanguageSelect($event)" (onDeSelect)="onLanguageSelect($event)"
                                (onDeSelectAll)="onLanguageSelect($event)" fixSearchBug>
                            </angular2-multiselect>
                        </div>
                        <div class="form-group col-lg-3 col-md-3 col-sm-12">
                            <label for="" class="d-flex justify-content-between align-items-center">Pro Reservation
                            </label>
                            <angular2-multiselect formControlName="ProReservation" [data]="proreservationList"
                                [(ngModel)]="selectedProReservation" [settings]="dropdownProReservation"
                                [ngClass]="{ 'is-invalid': submitted && f.ProReservation.errors }"
                                (onSelect)="onProReservationSelect($event)"
                                (onDeSelect)="onProReservationSelect($event)"
                                (onDeSelectAll)="onProReservationSelect($event)" fixSearchBug>
                            </angular2-multiselect>
                        </div>
                        <div class="form-group col-lg-3 col-md-3 col-sm-12">
                            <label for="" class="">Gender <span class="required">*</span>
                            </label>
                            <select class="form-control " formControlName="Gender"
                                [ngClass]="{ 'is-invalid': submitted && f.Gender.errors }">
                                <option value="">Select</option>
                                <option>Male</option>
                                <option>Female</option>
                            </select>
                            <div *ngIf="submitted && f.Gender.errors" class="invalid-feedback">
                                <div *ngIf="f.Gender.errors.required">
                                    Gender is required.
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="form-group col-lg-3 col-md-3 col-sm-12">
                            <div class="custom-control custom-checkbox">
                                <input type="checkbox" formControlName="IsVVIP"
                                    [ngClass]="{ 'is-invalid': submitted && f.IsVVIP.errors }" id="a"
                                    class="custom-control-input">
                                <label for="a" class="custom-control-label">VVIP</label>
                            </div>
                        </div>
                        <div class="form-group col-lg-3 col-md-3 col-sm-12">

                            <div class="custom-control custom-checkbox">
                                <input type="checkbox" formControlName="IsFactoryVisit"
                                    [ngClass]="{ 'is-invalid': submitted && f.IsFactoryVisit.errors }" id="b"
                                    class="custom-control-input">
                                <label for="b" class="custom-control-label">Factory Visit</label>
                            </div>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-lg-3 col-md-3 col-sm-12">
                            <label for="" class="d-flex justify-content-between align-items-center">Factory Visit
                                Type/Comments
                            </label>
                            <textarea class="form-control  form-control-sm" formControlName="FactoryVisitComments"
                                [ngClass]="{ 'is-invalid': submitted && f.FactoryVisitComments.errors }"
                                (input)="NameSpaceNotAllowed($event)" maxlength="500"></textarea>
                        </div>
                        <div class="form-group col-lg-3 col-md-3 col-sm-12">
                            <label for="" class="d-flex justify-content-between align-items-center">Comments
                            </label>
                            <textarea class="form-control form-control-sm" formControlName="Comments"
                                [ngClass]="{ 'is-invalid': submitted && f.Comments.errors }"
                                (input)="NameSpaceNotAllowed($event)" maxlength="500"></textarea>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-lg-12">
                            <button type="submit" href="javascript:void(0);" class="btn btn-info"
                                (click)="onSubmit()">Save
                                <span class="text-center ml-2" *ngIf="submitted">
                                </span>
                            </button>
                            <button href="javascript:void(0);" class="btn btn-secondary ml-2"
                                routerLink="/contacts/contacts-list">Cancel</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>